import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { Section } from "@/components/UI";

export default function NewsArticle() {
  const { slug } = useParams();
  const [a, setA] = useState(null);
  const [notFound, setNotFound] = useState(false);
  useEffect(() => { api.get(`/news/${slug}`).then((r) => setA(r.data)).catch(() => setNotFound(true)); }, [slug]);

  if (notFound) return <Section className="pt-40 pb-32 text-center"><p className="text-ccpm-taupe">Article not found.</p><Link to="/news" className="text-ccpm-olive mt-4 inline-block">← Back to News</Link></Section>;
  if (!a) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="animate-spin text-ccpm-olive" /></div>;

  return (
    <article>
      <Section className="pt-36 pb-10">
        <Link to="/news" className="inline-flex items-center gap-2 text-sm text-ccpm-olive hover:underline mb-8" data-testid="article-back"><ArrowLeft size={16} /> News & Advocacy</Link>
        <span className="overline text-ccpm-olive block">{a.category} · {a.author}</span>
        <h1 className="font-serif text-4xl lg:text-6xl text-ccpm-charcoal leading-[1.03] tracking-tight mt-5 max-w-4xl">{a.title}</h1>
        <p className="mt-6 text-lg text-ccpm-taupe font-light max-w-2xl leading-relaxed">{a.excerpt}</p>
      </Section>
      {a.cover_image && (
        <Section className="pb-14"><div className="aspect-[16/8] overflow-hidden bg-ccpm-stone"><img src={a.cover_image} alt={a.title} className="w-full h-full object-cover" /></div></Section>
      )}
      <Section className="pb-32">
        <div className="max-w-2xl">
          {a.body.split("\n").filter((p) => p.trim()).map((p, i) => (
            <p key={i} className="text-ccpm-charcoal/90 leading-[1.9] mb-6 text-[1.05rem] font-light">{p}</p>
          ))}
        </div>
      </Section>
    </article>
  );
}
